var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { defaultColors } from '@hn-ui/themes';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-o5p5c0" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 16px;\n  border-radius: 16px;\n  background: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 16px;\n  border-radius: 16px;\n  background: ", ";\n"])), function (_a) {
    var bg = _a.bg;
    return bg;
});
var Text = styled.span.withConfig({ displayName: "Text", componentId: "sc-146yc7f" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-family: Noto Sans, sans-serif;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"], ["\n  color: ", ";\n  font-family: Noto Sans, sans-serif;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black100;
});
var config = {
    scheduled: { color: defaultColors.blue60, text: 'scheduled' },
    active: { color: defaultColors.green60, text: 'active' },
    canceled: { color: defaultColors.black80, text: 'canceled' },
    completed: { color: defaultColors.purple50, text: 'completed' },
};
var Badge = function (_a) {
    var state = _a.state, rest = __rest(_a, ["state"]);
    var _b = config[state], color = _b.color, text = _b.text;
    return (_jsx(Container, __assign({ bg: color }, rest, { children: _jsx(Text, { children: text }, void 0) }), void 0));
};
export { Badge };
var templateObject_1, templateObject_2;
